<main class="flex column">
  <button
    payee-button
    class="top-margin-25 bottom-margin-15"
    (click)="createProductDiscount()"
  >
    Kedvezmény létrehozása
  </button>

  <div class="claim-amount-container top-margin-20">
    <payee-form-field width="wide">
      <span payee-label>Követelés összege</span>
      <input
        payee-input
        [formControl]="claimAmount"
      />
    </payee-form-field>
  </div>

  @if (!loading()) {
    <table
      mat-table
      class="top-margin-20 mat-elevation-z1"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="product">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Termék neve
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.product.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="fee">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Díj neve
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.fee.label }}
        </td>
      </ng-container>
      <ng-container matColumnDef="product_discountable_type">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Kedvezményezett típusa
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.product_discountable.type }}
        </td>
      </ng-container>
      <ng-container matColumnDef="product_discountable_name">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Kedvezményezett neve
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.product_discountable.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="fee_before_discount">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Díj kedvezmény előtt
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.fee_before_discount | currency: element.fee.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="discount">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Kedvezmény mértéke
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          @if (element.discount_type === "percentage") {
            <span>{{ element.discount }} %</span>
          }
          @if (element.discount_type === "amount") {
            <span>
              {{ element.discount | currency: element.fee.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="fee_after_discount">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Díj kedvezmény után
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.fee_after_discount | currency: element.fee.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            color="white"
            payee-icon-button
            (click)="editProductDiscount(element)"
          >
            <payee-icon name="edit-grey"></payee-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            color="white"
            payee-icon-button
            (click)="deleteProductDiscount(element)"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </td>
      </ng-container>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
        class="main-header"
      ></tr>
      <tr
        *matRowDef="let element; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  }

  <mat-paginator
    disableUnderline
    class="mat-elevation-z1"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25, 100]"
    [length]="length"
    (page)="pageChange($event)"
  ></mat-paginator>
</main>

@if (loading()) {
  <mat-progress-spinner
    class="loading-spinner"
    color="accent"
    diameter="100"
    mode="indeterminate"
  ></mat-progress-spinner>
}
